import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import Disclaimers from '../Disclaimers';

const ErrorUnhandled = () => {
  useRUMView('error_unhandled');

  return (
    <Screen
      header="Currently experiencing issues processing your application."
      subheader="Please try again later."
    >
      <Disclaimers textAlign="center">
        Please note that your credit score was not affected.
      </Disclaimers>
    </Screen>
  );
};

export default ErrorUnhandled;
